import React from 'react';
import PropTypes from 'prop-types';
import Box from '../Box/Box';
import BrandSelectItem from './BrandSelectItem';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
BrandSelect component
*/
function BrandSelect(_ref) {
  var children = _ref.children,
    className = _ref.className,
    title = _ref.title;
  var cssClasses = ['st_brandselect'];
  cssClasses = addClassNames(className, cssClasses);
  var count = React.Children.count(children);
  var columns = 0;
  if (count === 0) return null;
  if (count <= 4) {
    columns = count;
  } else if (count <= 6) {
    columns = 3;
  } else {
    columns = 4;
  }
  return /*#__PURE__*/_jsx("div", {
    className: cssClasses.join(' '),
    children: /*#__PURE__*/_jsxs(Box, {
      className: "st_brandselect__box",
      children: [/*#__PURE__*/_jsx(Box.Title, {
        children: title
      }), /*#__PURE__*/_jsx(Box.Content, {
        padding: {
          vertical: 'md',
          horizontal: 'mlg'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "st_brandselect__grid st_brandselect__grid--".concat(columns),
          children: children
        })
      })]
    })
  });
}
process.env.NODE_ENV !== "production" ? BrandSelect.propTypes = {
  /** title for Brand Select box */
  title: PropTypes.string,
  /** extra CSS classes, if any */
  className: classNamePropTypes
} : void 0;
BrandSelect.defaultProps = {
  title: 'Select Brand',
  className: null
};
BrandSelect.Item = BrandSelectItem;
export default BrandSelect;